import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  min-height: ", ";\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  line-height: 0;\n  margin-left: ", ";\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  margin-left: ", ";\n  white-space: nowrap;\n  word-wrap: normal;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  flex-shrink: 0;\n  margin-right: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  overflow: hidden;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  position: relative;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { ellipsis, rgba, position } from 'polished';
import { Card, Loader } from '@scp/ui-shared/components';
import { Paragraph, Subtext } from '@scp/ui-shared/components/typography';
import { color } from '@scp/ui-shared/theme/variables';
import { getE2eLabel } from '@scp/ui-shared/components/utils';
import { FileIcon, parseFileSize } from '@scp/ui-shared/features/files';
import { baselineToPx } from '@scp/ui-shared/theme/utils';
var E2E_FILE_NAME = 'file-name';
var E2E_FILE_CARD = 'file-card';
var MainWrapper = styled.div(_templateObject());
var Content = styled.div(_templateObject2());
var Title = styled(Paragraph).attrs({
  noMargin: true,
  bold: true
})(_templateObject3(), ellipsis());
var Wrapper = styled.div(_templateObject4());
var FileIconWrapper = styled.div(_templateObject5(), baselineToPx(2));
var TitleRow = styled.div(_templateObject6());
var Row = styled.div(_templateObject7());
var Size = styled(Paragraph).attrs({
  as: 'span',
  noMargin: true
})(_templateObject8(), baselineToPx(2));
var LoaderWrapper = styled.div(_templateObject9(), rgba(color.background, 0.8), position('absolute', 0));
var Status = styled.div(_templateObject10(), baselineToPx(1));
var CardComponent = styled(Card)(_templateObject11(), baselineToPx(12));
export var FileCard = function FileCard(_ref) {
  var item = _ref.item,
      isLoading = _ref.isLoading,
      subtext = _ref.subtext,
      status = _ref.status,
      actions = _ref.actions;
  return React.createElement(MainWrapper, null, React.createElement(CardComponent, {
    actions: isLoading ? [] : actions,
    secondary: true,
    innerVerticalMargin: 4,
    innerHorizontalMargin: 8,
    dataE2e: getE2eLabel(E2E_FILE_CARD)
  }, React.createElement(Content, null, React.createElement(FileIconWrapper, null, React.createElement(FileIcon, {
    mimeType: item.mimeType,
    size: 24,
    color: color.icon
  })), React.createElement(Wrapper, null, React.createElement(TitleRow, null, React.createElement(Title, {
    "data-e2e": getE2eLabel(E2E_FILE_NAME),
    title: item.name
  }, item.name), React.createElement(Size, null, parseFileSize(item.size))), React.createElement(Row, null, React.createElement(Subtext, null, subtext), React.createElement(Status, null, status))))), isLoading && React.createElement(LoaderWrapper, null, React.createElement(Loader, {
    size: 24
  })));
};